const decoder = document.createElement( 'div' );

export default function( str ) {

	decoder.innerHTML = str;
	return decoder.innerText;

};